import { createSelector } from 'reselect'
import { orderBy } from 'lodash'
import { DateTime } from 'luxon'
import { ReduxState } from '@/utils/typeHelpers'
import { UserImportantDate } from './userImportantDates.slice'

export const userImportantDates = (state: ReduxState) =>
  Object.values(state.userImportantDates)

export const getNonDeletedImportantDates = createSelector(
  [userImportantDates],
  (userImportantDates) =>
    userImportantDates.filter(
      (userImportantDates) =>
        !userImportantDates.deletedAt &&
        !userImportantDates.actionItem.deletedAt
    )
)

export const getUserImportantDatesBetween = createSelector(
  [
    userImportantDates,
    (
      _: unknown,
      args: {
        startDateParam: DateTime
        endDateParam: DateTime
        count: number | null
        filterCondition?: (importantDate: UserImportantDate) => boolean
      }
    ) => args,
  ],
  (userImportantDates, args) => {
    // .endsAt is required for user_important_dates, so we're sorting based on this property
    // select override or pick default ends at
    const ordered: UserImportantDate[] = orderBy(
      userImportantDates,
      (d) => {
        const endDate = d.endsAt || d.actionItem.endsAt
        return endDate && new Date(endDate)
      },
      ['asc']
    )

    // Filter so we are left with important dates falling between startDate and endDate (both inclusive)
    const filtered = ordered.filter((d) => {
      const itemDt = DateTime.fromISO(d.endsAt || d.actionItem.endsAt || '', {
        zone: 'utc',
      })
      if (itemDt >= args.startDateParam && itemDt <= args.endDateParam) {
        if (args.filterCondition) {
          return args.filterCondition(d)
        }
        return true
      }

      return false
    })

    if (args.count !== null) {
      return filtered.slice(0, args.count)
    }

    return filtered
  }
)
